





































































































































































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import FileUpload from "vue-upload-component";
import { Validator } from "vee-validate";
import { formatDateTimeString } from "@/shared/dateString";
import { useNotifierStore } from "@/shared/store/notifier";
import { useOpenSearchIndexStore } from "@/admin/store/openSearchIndex";
import { OpenSearchIndex, OpenSearchDomainDetail } from "@/admin/types";
@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner
  }
})
export default class OpenSearchUtilityVue extends Vue {
  formatDateTimeString = formatDateTimeString;
  $validator: Validator;
  notifierStore = useNotifierStore();

  openSearchIndexStore = useOpenSearchIndexStore();

  created () {
    this.openSearchIndexStore.getOpenSearchIndexInfo();
    this.openSearchIndexStore.getOpenSearchDomainDetails();
  }
  get isLoading () {
    return !this.openSearchIndexStore.isLoaded;
  }
  isSubmitting = false;
  showConfirmModal = false;
  showDetailModal = false;
  dropAndRecreateIndex = false;
  indexToReindex = null;
  isFileSubmitting = false;
  files = [];
  listFields = [
    {
      key: "name",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Index Name"
    },
    {
      key: "aliases",
      label: "Aliases",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "properties",
      label: "Properties",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "action",
      label: "",
      thClass: "text-left",
      tdClass: "text-left"
    }
  ];
  get openSearchIndex (): OpenSearchIndex {
    return this.openSearchIndexStore.osIndex;
  }
  get tableFields () {
    return this.openSearchIndexStore.osIndex ? this.openSearchIndexStore.osIndex.indexDetails : [];
  }
  indexClick () {
     if (this.isSubmitting) { return; }
     this.isSubmitting = true;
     this.$validator.validate()
      .then(result => {
        if (result) {
          return this.openSearchIndexStore.putOpenSearchIndexRequest({
            index: this.indexToReindex,
            partnerId: 0,
            employerId: 0,
            dropAndRecreateIndex: this.dropAndRecreateIndex
          });
        }
      })
      .finally(() => {
        this.indexToReindex = null;
        this.isSubmitting = false;
        this.showConfirmModal = false;
        this.dropAndRecreateIndex = false;
      });
  }
  cancelReindex () {
    this.showConfirmModal = false;
    this.dropAndRecreateIndex = false;
  }
  showConfirmReIndex (index: string) {
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }
        this.indexToReindex = index;
        this.showConfirmModal = true;
      });
  }
  onClose () {
    this.showConfirmModal = false;
    this.dropAndRecreateIndex = false;
  }
  get packageTableFields () {
    return this.openSearchIndexStore.osIndex ? this.openSearchIndexStore.osIndex.packages : [];
  }
  get hasPackages () {
    return this.packageTableFields.length > 0;
  }
  packageFields = [
    {
      key: "packageName",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Package Name"
    },
    {
      key: "packageId",
      label: "ID",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "packageVersion",
      label: "Version",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "lastUpdated",
      label: "Last Updated",
      thClass: "text-left",
      tdClass: "text-left"
    }
  ];
  get fileNameDisplay (): string {
    return this.files.length > 0 ? this.files[0].name : "Click to select .txt synonym file with first name synonyms";
  }
  get submitDisabled () {
    return this.isFileSubmitting || this.files.length === 0;
  }
  submit () {
    if (this.files.length === 0) return;
    if (this.isFileSubmitting) return;

    this.isFileSubmitting = true;

    this.openSearchIndexStore.uploadSynonymFile(
      this.files[0].file
    )
    .then(() => {
      this.openSearchIndexStore.getOpenSearchIndexInfo();
    }).catch(() => null)
    .finally(() => {
      this.isFileSubmitting = false;
      this.files = [];
    });
  }
  refresh () {
    this.files = [];
    this.openSearchIndexStore.getOpenSearchIndexInfo();
  }
  closeDetails () {
    this.showDetailModal = false;
  }
  loadDetails () {
    if (this.openSearchIndexStore.isDomainDetailsLoaded) {
      this.showDetailModal = true;
    }
  }
  get canViewDetails (): boolean {
    return this.openSearchIndexStore.isDomainDetailsLoaded;
  }
  get domainDetails (): OpenSearchDomainDetail {
    return this.openSearchIndexStore.domainDetails;
  }
}
